module.exports = __webpack_public_path__ + "static/media/10.question_loop.9495b9c7.mp4";